import { HttpClient } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";
import { UrlTool } from "_fil_local_addon/camc-cms-base/index";
import FundReportService from "_fil_local_addon/camc-fund-report-list/fund_report_service";

class CAMCFundTenHolding {
    constructor(fundCode) {
        this.fundCode = fundCode;
        this.reportTime = null;
        this.httpClient = new HttpClient();
        this.fund_portfolio_equity_api = FUND_API_SOURCES.FUND_PORTFOLIO_EQUITY_SOURCE;
    }

    async render() {
        try {
            this.reportTime = await FundReportService.getReportTime(this.fundCode);
            if (!this.reportTime) {
                this.setEmptyMessage();
                return;
            } else {
                const equityApiData = await this.getEquityData();
                this.renderEquityData(equityApiData);
            }
        } catch (error) {
            this.setEmptyMessage();
            return;
        }
    }

    async getEquityData() {
        const equityUrl = UrlTool.addPath(this.fund_portfolio_equity_api, this.fundCode);
        let options = {
            errorHandler: () => {
                this.errorHandler();
            },
            data: {
                asat: this.reportTime,
            },
        };
        const equityApiData = await this.httpClient.get(equityUrl, options);
        return equityApiData;
    }

    renderEquityData(equityApiData) {
        let equityDataArray = [];
        let equityResData = equityApiData.data;
        if (equityResData && equityResData.topSecurityList) {
            // const sortedList = equityResData.topSecurityList.sort((a, b) => parseInt(a.orderId) - parseInt(b.orderId));
            const sortedList = equityResData.topSecurityList;
            for (var i = 0; i < sortedList.length; i++) {
                equityDataArray.push(sortedList[i]);
            }
        }

        this.updateFundDate(this.reportTime);
        this.generateEquityChart(equityDataArray);
    }

    setEmptyMessage(containerId) {}

    errorHandler() {}

    updateFundDate(date) {}

    generateEquityChart(equityDataArray) {}
}

export default CAMCFundTenHolding;
